module.exports = __webpack_public_path__ + "static/img/default_head.9a214129.png";